import modules_webReport from './webReport/index.js'
import modules_paymentType from './paymentType/index.js'
import modules_paymentOperation from './paymentOperation/index.js'
import modules_paymentMethod from './paymentMethod/index.js'
import modules_paymentDirection from './paymentDirection/index.js'
import modules_paymentCategory from './paymentCategory/index.js'
import modules_paymentAccount from './paymentAccount/index.js'
import modules_ownerLegal from './ownerLegal/index.js'
import modules_gender from './gender/index.js'
import modules_dateStep from './dateStep/index.js'
import modules_dates from './dates/index.js'
import modules_currency from './currency/index.js'
import modules_citizenship from './citizenship/index.js'
import modules_certificatesType from './certificatesType/index.js'
import modules_cash from './cash/index.js'
import modules_ageCategory from './ageCategory/index.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    modules:{
        ageCategory: modules_ageCategory,
        cash: modules_cash,
        certificatesType: modules_certificatesType,
        citizenship: modules_citizenship,
        currency: modules_currency,
        dates: modules_dates,
        dateStep: modules_dateStep,
        gender: modules_gender,
        ownerLegal: modules_ownerLegal,
        paymentAccount: modules_paymentAccount,
        paymentCategory: modules_paymentCategory,
        paymentDirection: modules_paymentDirection,
        paymentMethod: modules_paymentMethod,
        paymentOperation: modules_paymentOperation,
        paymentType: modules_paymentType,
        webReport: modules_webReport,
    },
}